import React from 'react';
import DeviceExpanded from "./DeviceExpanded";
import {getColor, getColorDots} from "./utils/colors/colors";
import withRealTime from "./hocs/public-api/real-time/withRealTime";
import PropTypes from 'prop-types';
import Device from "./Device";
import withDevice from "./hocs/public-api/devices/withDevice";
import {compose} from "recompose";
import {getRoomTypeLabel} from "./commons/roomTypes";

const DeviceWidget = ({serial, room, expanded, realTime, device, selected, ...props}) => {
    if (!device) return false;

    let color;
    if (!realTime || realTime.status === 'offline') {
        color = 'secondary'
    } else {
        const dots = getColorDots('iaq', realTime['iaq']);
        color = getColor('iaq', dots);
    }

    let status = (realTime && realTime.status) || 'loading...';

    const DeviceComponent = expanded ? DeviceExpanded : Device;

    return (
        <DeviceComponent
            serial={serial}
            room={`${getRoomTypeLabel(device['roomType'])} (${device["name"]})`}
            model={'ProSense'}
            status={status}
            color={color}
            realTime={realTime}
            selected={selected}
        />
    );
};

DeviceWidget.propTypes = {
    serial: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired,
    selected: PropTypes.bool.isRequired,
};

DeviceWidget.defaultProps = {
    expanded: false,
    selected: false
};

export default compose(
    withRealTime(),
    withDevice()
)(DeviceWidget);
